<div class="container">
  <form class="row bordered-container" (ngSubmit)="setPwd()">
    <div class="offset-sm-3 col-sm-6 bordered-content">
      <div class="row pc2-form-group" [attr.data-hidden]="isSet">
        <label class="col-form-label col-sm-4 text-sm-right">New password:</label>
        <div class="col-sm-8">
          <input type="password" class="form-control custom-form-control" [(ngModel)]="pwd" [ngModelOptions]="{standalone: true}" (input)="onPasswordInput()"/>
          <ul class="list-unstyled mt-1" style="font-size: 0.85em;" *ngIf="pwd">
            <li [style.color]="passwordRules.minLength ? 'green' : '#999'">
              {{passwordRules.minLength ? '&#10003;' : '&#10007;'}} At least 8 characters
            </li>
            <li [style.color]="passwordRules.hasLower ? 'green' : '#999'">
              {{passwordRules.hasLower ? '&#10003;' : '&#10007;'}} At least one lowercase letter
            </li>
            <li [style.color]="passwordRules.hasUpper ? 'green' : '#999'">
              {{passwordRules.hasUpper ? '&#10003;' : '&#10007;'}} At least one uppercase letter
            </li>
            <li [style.color]="passwordRules.hasDigit ? 'green' : '#999'">
              {{passwordRules.hasDigit ? '&#10003;' : '&#10007;'}} At least one digit
            </li>
            <li [style.color]="passwordRules.hasSpecial ? 'green' : '#999'">
              {{passwordRules.hasSpecial ? '&#10003;' : '&#10007;'}} At least one special character
            </li>
          </ul>
        </div>
      </div>
      <div class="row pc2-form-group" [attr.data-hidden]="isSet">
        <div class="offset-sm-4 col-sm-8">
          <button class="btn btn-primary btn-block" type="submit" [disabled]="!isPasswordValid()">Set Password</button>
        </div>
      </div>
      <div class="row pc2-form-group" [attr.data-hidden]="isSet" *ngIf="error === 422">
        <div class="col-12 text-danger text-center">
          Password does not meet security requirements
        </div>
      </div>
      <div class="row pc2-form-group" [attr.data-hidden]="!isSet">
        <h4 class="text-info text-center col-12">
          Password has been set successfully!
        </h4>
        <div class="text-center col-12">
          <button class="btn btn-primary" routerLink="/login">Login</button>
        </div>
      </div>
    </div>
  </form>
</div>
